import { render, staticRenderFns } from "./Add-Customer.vue?vue&type=template&id=54cc8c0e&"
import script from "./Add-Customer.vue?vue&type=script&lang=js&"
export * from "./Add-Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports